module.exports = __webpack_public_path__ + "img/fatherhood_14.48b39f7b.jpg";